import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";import BannerImg from "../assets/Images/Banner.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import DownloadLogo from "../assets/Images/downloadicon.png";
import PdfLogo from "../assets/Images/pdf.png";
import Decoacademylogo from "../assets/Images/decoacademylogo.jpeg";
import "./Renovation1plus_hk.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Renovation1plusHk = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("hk_renovation_guideline")}</h1>
          <p className="banner-subtitle">{t("hk_renovation_guideline_plus")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("home")} &gt; </Link>
        <span>{t("hk_renovation_guideline_plus")}</span>
      </Breadcrumbs>
      <main className="renovation-plus-main-container">
        <section className="renovation-plus-content-section">
          <header className="renovation-plus-header">
            <img src={Decoacademylogo} alt="" className="renovation-plus-logo" />
            <h1 className="renovation-plus-title">{t("renovation1plus_p1")}</h1>
            <h2 className="renovation-plus-subtitle">{t("renovation1plus_p2")}</h2>
          </header>
          <div className="renovation-plus-text-content">
            <p>{t("renovation1plus_p3")}</p>
            <p>{t("renovation1plus_p4")}</p>
            <p>{t("renovation1plus_p5")}</p>
          </div>
          <div className="renovation-plus-download-section">
            <div className="renovation-plus-pdf-info">
              <img src={PdfLogo} alt="" className="renovation-plus-pdf-icon" />
              <span>{t("renovation1plus_p6")}</span>
            </div>
            <a href="https://www.hkarbsoc.org.hk/public/reno1.0_full.pdf" className="renovation-plus-download-link">
              <img src={DownloadLogo} alt="Download" className="renovation-plus-download-icon" />
            </a>
          </div>
          <div className="renovation-plus-footer-content">
            <p>{t("renovation1plus_p7")}</p>
            <p>
              <a href="https://www.hkdea.com/tc/industrial-guideline.php" className="renovation-plus-external-link">
                https://www.hkdea.com/tc/industrial-guideline.php
              </a>
            </p>
          </div>
          <hr className="renovation-plus-divider" />
        </section>
      </main>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>

      <Footer />
    </>
  );
};

export default Renovation1plusHk;
